import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { 
    Button, 
    Dialog, 
    DialogContent, 
    DialogTitle,
    Typography
} from '@material-ui/core';
import { LocaleConsumer } from 'containers/locale/LocaleProvider';

const styles = {
    dialog: {
        width: '80%',
    },
};

function CannotCancelModal({
    classes,
    open,
    onRequestClose
}) {

    return (
        <LocaleConsumer>
            {({ getTranslation }) => (
                <Dialog
                    onClose={onRequestClose}
                    open={open}
                    classes={{ paper: classes.dialog }}
                >
                    <DialogTitle>{getTranslation("user_account_cancel_title")}</DialogTitle>
                    <DialogContent>
                        <Typography>
                            {getTranslation("user_account_cannot_cancel")}
                        </Typography>
                        <br />
                        <Button 
                            onClick={onRequestClose} 
                        >
                            {getTranslation("cancel")}
                        </Button>
                    </DialogContent>
                </Dialog>
            )}
        </LocaleConsumer>
    );
}

export default withStyles(styles)(CannotCancelModal);
